import { lazy } from 'react';

export const ResultPageLazy = lazy(() => import('./result'));
